module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};


//////////////////
// WEBPACK FOOTER
// ../~/react-helmet/~/core-js/modules/_fails.js
// module id = 329
// module chunks = 3